module.exports = __webpack_public_path__ + "static/student-sandbox-bg-sm-f83fda659e7fc779146ba1bc76084dd4.jpg";